import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Scale } from 'lucide-react';
import { MenuButton } from '../components/NavigationMenu';

const AvisoLegalPage = () => {
  return (
    <div className="min-h-screen bg-[#1a2b3c] text-[#f5f5dc]">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-[#1a2b3c]/95 backdrop-blur-sm border-b border-[#50c878]/20">
        <div className="flex items-center justify-between px-4 py-3">
          <div className="flex items-center gap-3">
            <MenuButton />
            <Link 
              to="/" 
              className="flex items-center gap-2 text-[#f5f5dc]/60 hover:text-[#f5f5dc] transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              <span className="text-sm hidden sm:inline">Volver</span>
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="pt-20 pb-12 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto">
        <div className="flex items-center gap-4 mb-8">
          <div className="w-12 h-12 rounded-full bg-[#50c878]/20 flex items-center justify-center">
            <Scale className="w-6 h-6 text-[#50c878]" />
          </div>
          <h1 className="text-3xl sm:text-4xl font-cinzel text-[#f5f5dc]">Aviso Legal</h1>
        </div>

        <div className="prose prose-invert max-w-none space-y-6">
          <section className="bg-[#0d1620] rounded-xl p-6 border border-[#50c878]/20">
            <h2 className="text-xl font-semibold text-[#f5f5dc] mb-4">1. Información Identificativa</h2>
            <p className="text-[#f5f5dc]/70 leading-relaxed mb-4">
              En cumplimiento con el deber de información recogido en el artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y del Comercio Electrónico, a continuación se reflejan los siguientes datos:
            </p>
            <ul className="space-y-2 text-[#f5f5dc]/70">
              <li><strong className="text-[#f5f5dc]">Titular del sitio web:</strong> Versión Digital S.L.</li>
              <li><strong className="text-[#f5f5dc]">Domicilio social:</strong> Calle Martínez Ferrando 6, CD. 46004, Valencia</li>
              <li><strong className="text-[#f5f5dc]">C.I.F.:</strong> B98660459</li>
              <li><strong className="text-[#f5f5dc]">Datos de Inscripción en el Registro Mercantil:</strong> Inscrita en el Registro Mercantil de Valencia (Tomo 9841, Libro 7123, Folio 13, Hoja V-161127)</li>
              <li><strong className="text-[#f5f5dc]">Correo electrónico de contacto:</strong> administracion@versiondigital.es</li>
              <li><strong className="text-[#f5f5dc]">Teléfono de contacto:</strong> 961 82 03 28</li>
            </ul>
          </section>

          <section className="bg-[#0d1620] rounded-xl p-6 border border-[#50c878]/20">
            <h2 className="text-xl font-semibold text-[#f5f5dc] mb-4">2. Usuarios y Condiciones de Uso</h2>
            <p className="text-[#f5f5dc]/70 leading-relaxed mb-4">
              El acceso y/o uso de este portal de Versión Digital S.L. atribuye la condición de USUARIO, que acepta, desde dicho acceso y/o uso, las Condiciones Generales de Uso aquí reflejadas. Las citadas Condiciones serán de aplicación independientemente de las Condiciones Generales de Contratación que en su caso resulten de obligado cumplimiento.
            </p>
            <p className="text-[#f5f5dc]/70 leading-relaxed">
              La web www.amagnificentlife.es proporciona el acceso a multitud de informaciones, servicios o datos (en adelante, "los contenidos") en Internet pertenecientes a Versión Digital S.L. o a sus licenciantes a los que el USUARIO pueda tener acceso.
            </p>
          </section>

          <section className="bg-[#0d1620] rounded-xl p-6 border border-[#50c878]/20">
            <h2 className="text-xl font-semibold text-[#f5f5dc] mb-4">3. Propiedad Intelectual e Industrial</h2>
            <p className="text-[#f5f5dc]/70 leading-relaxed mb-4">
              Versión Digital S.L. por sí o como cesionaria, es titular de todos los derechos de propiedad intelectual e industrial de su página web, así como de los elementos contenidos en la misma (a título enunciativo: imágenes, sonido, audio, vídeo, software o textos; marcas o logotipos, combinaciones de colores, estructura y diseño, selección de materiales usados, programas de ordenador necesarios para su funcionamiento, acceso y uso, etc.).
            </p>
            <p className="text-[#f5f5dc]/70 leading-relaxed">
              Queda expresamente prohibida la reproducción, distribución y comunicación pública, incluida su modalidad de puesta a disposición, de la totalidad o parte de los contenidos de esta página web, con fines comerciales, en cualquier soporte y por cualquier medio técnico, sin la autorización previa y por escrito de Versión Digital S.L.
            </p>
          </section>

          <section className="bg-[#0d1620] rounded-xl p-6 border border-[#50c878]/20">
            <h2 className="text-xl font-semibold text-[#f5f5dc] mb-4">4. Exclusión de Garantías y Responsabilidad</h2>
            <p className="text-[#f5f5dc]/70 leading-relaxed">
              Versión Digital S.L. no se hace responsable, en ningún caso, de los daños y perjuicios de cualquier naturaleza que pudieran ocasionar, a título enunciativo: errores u omisiones en los contenidos, falta de disponibilidad del portal o la transmisión de virus o programas maliciosos o lesivos en los contenidos, a pesar de haber adoptado todas las medidas tecnológicas necesarias para evitarlo.
            </p>
          </section>

          <section className="bg-[#0d1620] rounded-xl p-6 border border-[#50c878]/20">
            <h2 className="text-xl font-semibold text-[#f5f5dc] mb-4">5. Enlaces (Links)</h2>
            <p className="text-[#f5f5dc]/70 leading-relaxed">
              En el caso de que en www.amagnificentlife.es se dispusiesen enlaces o hipervínculos hacía otros sitios de Internet, Versión Digital S.L. no ejercerá ningún tipo de control sobre dichos sitios y contenidos. En ningún caso Versión Digital S.L. asumirá responsabilidad alguna por los contenidos de algún enlace perteneciente a un sitio web ajeno.
            </p>
          </section>

          <section className="bg-[#0d1620] rounded-xl p-6 border border-[#50c878]/20">
            <h2 className="text-xl font-semibold text-[#f5f5dc] mb-4">6. Protección de Datos</h2>
            <p className="text-[#f5f5dc]/70 leading-relaxed">
              Versión Digital S.L. cumple con las directrices del Reglamento General de Protección de Datos (RGPD) 2016/679 y la Ley Orgánica 3/2018 de Protección de Datos Personales y garantía de los derechos digitales. Para más información sobre el tratamiento de sus datos, consulte nuestra{' '}
              <Link to="/politica-privacidad" className="text-[#50c878] hover:underline">Política de Privacidad</Link>.
            </p>
          </section>

          <section className="bg-[#0d1620] rounded-xl p-6 border border-[#50c878]/20">
            <h2 className="text-xl font-semibold text-[#f5f5dc] mb-4">7. Empleo de Cookies</h2>
            <p className="text-[#f5f5dc]/70 leading-relaxed">
              Versión Digital S.L. podrá utilizar cookies para personalizar y facilitar al máximo la navegación del USUARIO por su portal. Para más información, consulte nuestra{' '}
              <Link to="/politica-cookies" className="text-[#50c878] hover:underline">Política de Cookies</Link>.
            </p>
          </section>

          <section className="bg-[#0d1620] rounded-xl p-6 border border-[#50c878]/20">
            <h2 className="text-xl font-semibold text-[#f5f5dc] mb-4">8. Derecho de Exclusión</h2>
            <p className="text-[#f5f5dc]/70 leading-relaxed">
              Versión Digital S.L. se reserva el derecho a denegar o retirar el acceso al portal y/o los servicios ofrecidos sin necesidad de preaviso, a instancia propia o de un tercero, a aquellos usuarios que incumplan las presentes Condiciones Generales de Uso.
            </p>
          </section>

          <section className="bg-[#0d1620] rounded-xl p-6 border border-[#50c878]/20">
            <h2 className="text-xl font-semibold text-[#f5f5dc] mb-4">9. Legislación Aplicable y Jurisdicción</h2>
            <p className="text-[#f5f5dc]/70 leading-relaxed">
              La relación entre Versión Digital S.L. y el USUARIO se regirá por la normativa española vigente y cualquier controversia se someterá a los Juzgados y tribunales de la ciudad de Madrid, salvo que la ley aplicable disponga otra cosa.
            </p>
          </section>
        </div>

        <p className="mt-8 text-[#f5f5dc]/40 text-sm text-center">
          Última actualización: Marzo 2026
        </p>
      </main>
    </div>
  );
};

export default AvisoLegalPage;
